import { breakpoints, colors } from '@spritz-finance/ui'
import styled from 'styled-components'

const Container = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 30px;

    ${breakpoints.xsmall} {
        margin-top: 20px;
        margin-bottom: 20px;
    }
`

export const HorizontalLine = styled.h2`
    width: 160.88px;
    text-align: center;
    border-bottom: 1px solid var(--surface-3, ${colors.ltGrey});
    line-height: 0.1em;
    margin: 0px 0 0px;
    height: 6.5px;
`

export const Text = styled.div`
    padding: 0 10px;
    font-family: inherit;
    font-weight: 500;
    font-size: 11px;
    list-style: 13px;
    color: var(--text-secondary, ${colors.ltGrey});
    height: 13px;
`

const Divider = () => {
    return (
        <Container>
            <HorizontalLine />
            <Text>OR</Text>
            <HorizontalLine />
        </Container>
    )
}
export default Divider
